import { BackendModel, BackendService } from '../core/backend.service';

export class CategoriaAcuerdo extends BackendModel {

  static path = '/acuerdos/categorias/';

  static codInterna = 'VIACOTONE';

  id: number;
  description: string;
  imagen: string;

  constructor(protected backendService: BackendService, model?: CategoriaAcuerdo) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/categoria-acuerdo.model.ts